import React from 'react'
import './student-onboarding-card-modal-2023.css'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../../AdminTasks/adminTaskUtils'
import TaskCardSettingBar from '../../TaskCardModal2023/TaskCardSettingBar/TaskCardSettingBar'
import LooksLikeYouAreDonePopup from '../../WorfklowCardModal2023/LooksLikeYouAreDonePopup/LooksLikeYouAreDonePopup'
import Subtask2023 from '../../TaskCardModal2023/Subtask2023/Subtask2023'
import WebsiteInquiryCallSwitch from '../WebsiteInquiryCardModal2023/WebsiteInquryCallSwitch/WebsiteInquiryCallSwitch'
import { differenceInDays, setDay } from 'date-fns'
import IntroLessonTab from '../../CardModal/IntroLessonTab/IntroLessonTab'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const StudentOnboardingCardModal2023 = ({openWorkflowModal2023, setOpenWorkflowModal2023, setWorkflows, setShowNotes, closeTheStudentOnboardingModal, signalWorkflowBeingDeleted, setSelectFamilyToGetDistances}) => {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false)
    const [showDescription, setShowDescription] = React.useState(false)
    const [teacherList, setTeacherList] = React.useState([])
    const [instList, setInstList] = React.useState([])
    const [daysToOnboard, setDaysToOnboard] = React.useState('')
    React.useEffect(() => {
        taskCardAnimateIn('student-onboarding-card-modal-2023__wrapper', 'student-onboarding-card-modal-2023')
        getTeachers()
        getInstruments()
        getAndCalculateOnboardDateAndDuration()
    }, [])
    React.useEffect(() => setTheTabs())

    React.useEffect(() => {
        getTeachers()
    }, [openWorkflowModal2023.whichSchool])

    const checkForAutoClear = (val) => {
        val === "New Task..." && setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: ''})
    }

    const getTeachers = () => {
        axios.get(`${baseUrl}/rawteacherdata/${openWorkflowModal2023.whichSchool}`)
        .then((res) => setTeacherList(res.data))
        .catch((err) => console.log(err))
    }

    const getInstruments = () => {
        axios.get(`${baseUrl}/inst`)
        .then((res) => setInstList(res.data))
        .catch((err) => console.log(err))
    }

    const getAndCalculateOnboardDateAndDuration = () => {
        if(openWorkflowModal2023.familyId === 'none' || !openWorkflowModal2023.familyId) {

        } else {
            axios.get(`${baseUrl}/school-management/${openWorkflowModal2023.familyId}`).then((res) => {
                setDaysToOnboard(differenceInDays(new Date(), new Date(res.data.onboardDate)))
            })
            .catch((err) => console.log(err))
        }
    }

    const setTheTabs = () => {
        if(document.getElementById('modal-view-tasks') && document.getElementById('modal-view-description')) {
            if(showDescription === false) {
                document.getElementById('modal-view-tasks').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-tasks').style.color = "#000"
                document.getElementById('modal-view-description').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.color = "rgb(146, 146, 146)"
            } else {
                document.getElementById('modal-view-tasks').style.borderBottom = "1px solid rgb(146, 146, 146)"
                document.getElementById('modal-view-tasks').style.color = "rgb(146, 146, 146)"
                document.getElementById('modal-view-description').style.borderBottom = "2px solid #000"
                document.getElementById('modal-view-description').style.color = "#000"
            }
        }
    }

    const saveAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('student-onboarding-card-modal-2023__wrapper', 'student-onboarding-card-modal-2023')
        axios.put(`${baseUrl}/student-onboarding/${openWorkflowModal2023.todoId}`, openWorkflowModal2023, myHeader)
        .then((res) => {
            closeTheStudentOnboardingModal(res.data)
            setWorkflows(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setOpenWorkflowModal2023(false)
            setSelectFamilyToGetDistances(false)
        })
        .catch((err) => console.log(err))
    }

    const deleteAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('student-onboarding-card-modal-2023__wrapper', 'student-onboarding-card-modal-2023')
        axios.delete(`${baseUrl}/student-onboarding/${openWorkflowModal2023.todoId}`, myHeader)
        .then((res) => {
            signalWorkflowBeingDeleted(res.data.todoId)
            setWorkflows(prev => (prev.filter((todo) => todo.todoId !== res.data.todoId && todo)))
            setOpenWorkflowModal2023(false)
            setSelectFamilyToGetDistances(false)
        })
        .catch((err) => console.log(err))
    }

    const changeAlarm = (b) => {
        setOpenWorkflowModal2023({...openWorkflowModal2023, todoAlarm: b})
    }

    const changeTheyHaveBeenCalled = (b) => {
        setOpenWorkflowModal2023({...openWorkflowModal2023, theyHaveBeenCalled: b})
    }



    return(
        <div className='student-onboarding-card-modal-2023__wrapper' id='student-onboarding-card-modal-2023__wrapper' onClick={(e) => e.target.id === 'student-onboarding-card-modal-2023__wrapper' && (openWorkflowModal2023.todoSubtasks.filter((sub) => !sub.subtaskCompleted && sub).length > 0 ? saveAndCloseTask() : setIsPopupOpen(true))}>
            {isPopupOpen && <LooksLikeYouAreDonePopup saveAndCloseTask={saveAndCloseTask} deleteAndCloseTask={deleteAndCloseTask} />}
            <div className='student-onboarding-card-modal-2023' id='student-onboarding-card-modal-2023'>
                {parseInt(daysToOnboard) !== 0 && daysToOnboard && <div className='student-onboarding-card-modal-2023__days-to-onboard'>Onboarding for {parseInt(daysToOnboard) === 0 && 'hi'} days</div>}
                <input className='student-onboarding-card-modal-2023__task-name' value={openWorkflowModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenWorkflowModal2023({...openWorkflowModal2023, todoName: e.target.value})} />
                <TaskCardSettingBar openModal2023={openWorkflowModal2023} setOpenModal2023={setOpenWorkflowModal2023} />
                <div className="student-onboarding-card-modal-2023__two-sections-divider">
                    <div className="student-onboarding-card-modal-2023__modal-view-tabs" id="modal-view-tasks" onClick={() => setShowDescription(false)}>Tasks</div>
                    <div className="student-onboarding-card-modal-2023__modal-view-tabs" id="modal-view-description" onClick={() => setShowDescription(true)}>Intro Lesson(s)</div>
                </div>
                {showDescription ? <IntroLessonTab 
                    openWorkflowModal2023={openWorkflowModal2023} 
                    setOpenWorkflowModal2023={setOpenWorkflowModal2023} 
                    instList={instList}
                    teacherList={teacherList}
                />
                :
                <div className='student-onboarding-card-modal-2023__subtask__wrapper'>
                    {openWorkflowModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} setOpenModal2023={setOpenWorkflowModal2023} />)}
                    <div className='student-onboarding-card-modal-2023__add-subtask' onClick={() => setOpenWorkflowModal2023({...openWorkflowModal2023, todoSubtasks: [...openWorkflowModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
                    <div className='student-onboarding-card-modal-2023__subtask__toggle-switch'>
                        <WebsiteInquiryCallSwitch label={'Have Courtney Call:'} input={openWorkflowModal2023.todoAlarm} setToggle={changeAlarm} />
                        <WebsiteInquiryCallSwitch label={'Called:'} input={openWorkflowModal2023.theyHaveBeenCalled} setToggle={changeTheyHaveBeenCalled} />
                    </div>
                </div>
                }
            </div>
        </div>
    )
}
export default StudentOnboardingCardModal2023;